export const TABLE_PAGINATION_SCREEN_WIDTH_RESPONSIVE = 800 //px
